export default __webpack_public_path__ + "static/media/RFID.4d9893f8.png";